import workspace from "./workspace";

export const getBuildManifest = async ({
  organization,
  os_subset,
  architecture,
  group = null,
  agent = null,
}) => {
  const params = { organization, os_subset, architecture };
  if (group) params.group = group;
  if (agent) params.agent = agent;
  const response = await workspace.get("/build-manifest/", { params });
  return response.data;
};
